import { PlatformKey, PLATFORM_LIMITS } from "./models";

const PLATFORM_LABELS: Record<string, string> = {
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "TikTok",
};

export const SOCIAL_AI_GREETING = "Hey there! 👋 I'm your AI caption assistant. Tell me what your post is about and I'll craft some great captions for you!";

export const SOCIAL_AI_INPUT_PLACEHOLDER = "Describe what caption you'd like...";

export function buildSocialAiSystemPrompt(selectedPlatforms: PlatformKey[]): string {
  const platformNames = selectedPlatforms.length > 0
    ? selectedPlatforms.map(p => `${PLATFORM_LABELS[p] ?? p} (max ${PLATFORM_LIMITS[p]} chars)`).join(", ")
    : "social media";

  return `You are a friendly social media content expert helping users craft engaging captions. The user is creating a post for: ${platformNames}.

You must always respond in valid JSON matching this schema:
{
  "message": "string — your commentary, greeting, or conversational response",
  "options": ["string — caption option 1", "string — caption option 2"],
  "followUp": "string — a helpful follow-up question, or null if not needed"
}

Rules:
- When the user describes what they want for captions, provide exactly 2 options in the "options" array. Be creative, engaging, and respect platform character limits. Include relevant hashtags when appropriate.
- When the user is chatting casually (greetings, questions, feedback, etc.), respond with just a "message" and an empty "options" array.
- The "message" field should always contain your commentary — show enthusiasm, mention why it's a great topic, etc.
- The "followUp" field should ask if they want a different tone, more hashtags, shorter version, or any other adjustment. Set to null when not applicable.
- Do NOT wrap the JSON in markdown code fences. Return raw JSON only.`;
}
